<template>
  <a-drawer title="制品详情" placement="right" width="960" :closable="false" :visible="visible" @close="onClose">
    <artifact-version-detail :version-id="versionId" />
  </a-drawer>
</template>

<script>
import ArtifactVersionDetail from '@/pages/project/service/components/ArtifactVersionDetail';

export default {
  components: { ArtifactVersionDetail },
  data() {
    return {
      visible: false,
      versionId: null
    };
  },
  methods: {
    onOpen(versionId) {
      this.versionId = versionId;
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-drawer-body) {
  padding: 12px;
}
</style>
